import { membersApi } from "@services/apiMembersClient";

import { ResponsePaginationType } from "@_types/shared";
import {
  CreateStudentBlockUnblockInput,
  CreateStudentInput,
  CreateStudentMigrateInput,
  CreateStudentMigrateOutput,
  CreateStudentOutput,
  DeleteStudentByIdInput,
  GetStudentByEmailInput,
  GetStudentByIdOutput,
  GetStudentByIResponseOutput,
  GetStudentCheckInput,
  GetStudentCheckOutput,
  GetStudentInput,
  GetStudentOutput,
  GetStudentUncheckInput,
  GetStudentUncheckOutput,
  UpdateStudentByIdInput,
  UpdateStudentByIdOutput,
} from "@_types/students";
import { AxiosPromise } from "axios";

export const createStudent = ({ ...data }: CreateStudentInput): AxiosPromise<CreateStudentOutput> => {
  return membersApi.post("/students", { ...data });
};

export const getStudent = (params: GetStudentInput): AxiosPromise<ResponsePaginationType<GetStudentOutput>> => {
  return membersApi.get("/students", { params });
};

export const getStudentById = (uuid: string): AxiosPromise<GetStudentByIResponseOutput> => {
  return membersApi.get(`/students/${uuid}`);
};

export const getStudentByUserId = ({ userUuid }: { userUuid: string }): AxiosPromise<GetStudentByIdOutput> => {
  return membersApi.get(`/students/${userUuid}/byUser`);
};

export const getStudentByEmail = ({
  email,
}: GetStudentByEmailInput): AxiosPromise<ResponsePaginationType<GetStudentByIdOutput>> => {
  return membersApi.get(`/students?email=${email}`);
};

export const updateStudentById = (
  uuid: string,
  { ...data }: UpdateStudentByIdInput
): AxiosPromise<UpdateStudentByIdOutput> => {
  return membersApi.patch(`/students/${uuid}`, { ...data });
};

export const deleteStudentById = ({ uuid }: DeleteStudentByIdInput): AxiosPromise<void> => {
  return membersApi.delete(`/students/${uuid}`);
};

export const createStudentPayment = ({ ...data }: CreateStudentInput): AxiosPromise<CreateStudentOutput> => {
  return membersApi.post(`/students/payment`, { ...data });
};

export const createStudentMigrate = ({
  ...data
}: CreateStudentMigrateInput): AxiosPromise<CreateStudentMigrateOutput> => {
  return membersApi.post(`/students/migrate`, { ...data });
};

export const createStudentBlock = ({ uuids }: CreateStudentBlockUnblockInput) => {
  return membersApi.post("/students/to-block", { uuids });
};

export const createStudentUnblock = ({ uuids }: CreateStudentBlockUnblockInput) => {
  return membersApi.post("/students/to-unblock", { uuids });
};

export const getStudentCheck = ({
  studentUuid,
  contentUuid,
}: GetStudentCheckInput): AxiosPromise<GetStudentCheckOutput> => {
  return membersApi.get(`/students/${studentUuid}/${contentUuid}/check`);
};

export const getStudentUncheck = ({
  studentUuid,
  contentUuid,
}: GetStudentUncheckInput): AxiosPromise<GetStudentUncheckOutput> => {
  return membersApi.get(`/students/${studentUuid}/${contentUuid}/uncheck`);
};
